import { Button, Grid, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import React, { useEffect, useRef } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import styled from "styled-components";
import { Container } from "@mui/system";
import { useDispatch } from "react-redux";
import { setDate } from "../../Redux/Analysis/AnalysisSlice";
import gsap from "gsap";
function AnalysisForm() {
    const dispatch = useDispatch();
    const formik = useFormik({
        initialValues: {
            start_date: "",
            end_date: "",
        },

        onSubmit: (values) => {
            dispatch(setDate({ ...values }));
        },
    });

    const btnContainer = useRef();

    const handleReset = () => {
        formik.values.start_date = "";
        formik.values.end_date = "";
        dispatch(setDate({ start_date: "", end_date: "" }));
    };

    useEffect(() => {
        // gsap.from(btnContainer.current, { x: "500" });
    });

    return (
        <AnalysisFormContainer>
            <Container>
                <form onSubmit={formik.handleSubmit}>
                    <Typography variant="h5"> Filter Tools </Typography>
                    <Grid container mt={3}>
                        <Grid item mb={1} xs={12} md={6}>
                            <TextField
                                fullWidth
                                id="start_date"
                                name="start_date"
                                label="Start Date"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={formik.values.start_date}
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item mb={1} xs={12} md={6}>
                            <TextField
                                fullWidth
                                id="end_date"
                                name="end_date"
                                label="End Date"
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                value={formik.values.end_date}
                                onChange={formik.handleChange}
                            />
                        </Grid>
                        <Grid item xs={12} ref={btnContainer}>
                            <Button
                                sx={{ marginRight: "5px" }}
                                type="submit"
                                variant="contained"
                            >
                                <FilterAltIcon></FilterAltIcon>
                                Filter
                            </Button>
                            <Button
                                sx={{ marginRight: "5px" }}
                                color="error"
                                variant="outlined"
                                onClick={(e) => handleReset()}
                            >
                                <RestartAltIcon></RestartAltIcon>
                                Reset
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Container>
        </AnalysisFormContainer>
    );
}

const AnalysisFormContainer = styled.div`
    margin: 10px 0;
`;

export default AnalysisForm;
